import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import './MacroChart.css';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

function MacroChart({ macros }) {
  const data = {
    labels: ['Protein', 'Carbs', 'Fat'],
    datasets: [
      {
        data: [macros.protein * 4, macros.carbs * 4, macros.fat * 9],
        backgroundColor: [
          'rgba(54, 162, 235, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(255, 206, 86, 0.8)',
        ],
        borderColor: [
          'rgba(54, 162, 235, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(255, 206, 86, 1)',
        ],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.parsed || 0;
            const percentage = ((value / context.dataset.data.reduce((a, b) => a + b, 0)) * 100).toFixed(1);
            return `${label}: ${value}kcal (${percentage}%)`;
          }
        }
      }
    }
  };

  const proteinGrams = macros.protein.toFixed(1);
  const carbsGrams = macros.carbs.toFixed(1);
  const fatGrams = macros.fat.toFixed(1);

  return (
    <div className="macro-chart-container">
      <h3>Daily Macros</h3>
      <div className="chart-wrapper">
        <Doughnut data={data} options={options} />
      </div>
      <div className="macro-details">
        <div className="macro-item">
          <span className="macro-label">Protein:</span>
          <span className="macro-value">{proteinGrams}g</span>
        </div>
        <div className="macro-item">
          <span className="macro-label">Carbs:</span>
          <span className="macro-value">{carbsGrams}g</span>
        </div>
        <div className="macro-item">
          <span className="macro-label">Fat:</span>
          <span className="macro-value">{fatGrams}g</span>
        </div>
      </div>
    </div>
  );
}

export default MacroChart;
